import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import React from 'react'
interface IConfirmationMessageProps {
  open: boolean
  setOpen: (value: boolean) => void
  onClickAccept: () => void
  title: string
  content: string
}
const ConfirmationMessage: React.FC<IConfirmationMessageProps> = ({ open, setOpen, onClickAccept, title, content }) => {
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
        data-testid={'test-confirmation-message'}
      >
        <DialogTitle id='alert-dialog-slide-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-slide-description'>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary' data-testid={'test-confirmation-button-cancel'}>
            Cancelar
          </Button>
          <Button onClick={onClickAccept} color='primary' data-testid={'test-confirmation-button-acept'}>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
export default ConfirmationMessage
